import {
  ADMIN_USER_ROLE,
  MANAGER_USER_ROLE,
} from '../../../../../constants/user'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../../../Building'
import { REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER } from '../../RequestWizardForm.constants'

export function getBuildingsUserFilterParam({ role, value }) {
  if (role === ADMIN_USER_ROLE) {
    return {}
  }

  if (role === MANAGER_USER_ROLE) {
    return { responsible_user: value }
  }

  return { inhabitant: value }
}

export function getBuildingApiParams(values) {
  const user = values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_USER]

  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    ...(user ? getBuildingsUserFilterParam(user) : null),
  }
}
